import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'hiddenResource',
  standalone: true
})
export class HiddenResourceFilterPipe implements PipeTransform {
  transform(items: any[]): any[] {
    return items.filter(item => !item.hidden && !item.main);
  }
}
